module.exports = __webpack_public_path__ + "static/media/vector_down.2853dd02.svg";